<template>
  <div class="box">
    <regist-progress
      :statusList="statusList"
      :currentStatus="currentStatus"
    ></regist-progress>

    <div v-if="currentStatus == 1">
      <div class="content">
        <van-form ref="formData">
          <van-field
            v-model="name"
            label="姓名"
            placeholder="请输入真实姓名"
            @input="inputFunc"
           required
          />
          <van-field
            v-model="account"
            label="账号"
            placeholder="请输入登录账号"
            @input="inputFunc"
            required
          />
          <van-field
            v-model="psw"
            label="密码"
            placeholder="请输入登录密码"
            type="password"
            @input="inputFunc"
            required
            :rules="[{ validator, message: '必须包含数字、字母和特殊符号，长度至少8位' }]"
          />
          <van-field
            v-model="pswAgain"
            label="确认密码"
            placeholder="请再次输入登录密码"
            type="password"
            @input="inputFunc"
            required
            :rules="[{ validator: validatorAgain, message: '两次密码输入不一致' }]"
          />
          <!-- <van-field
            v-model="idCard"
            label="身份证号"
            placeholder="请输入身份证号"
            @input="inputFunc"
          /> -->
          <van-field
            v-model="recommand"
            disabled
            label="推荐人"
            placeholder="未查询到推荐信息"
            readonly
          />
        </van-form>
      </div>
      <div class="select-box" v-if="tenantId === '171926906302533'">
        <van-checkbox
          v-model="checked"
          shape="square"
          icon-size="14.5px"
          checked-color="#3377ff"
          >我已阅读并同意
        </van-checkbox>
        <div class="user-Protocol" @click="checkProtocol">用户注册协议</div>
      </div>
<!--      <div
        class="apply-btn"
        :style="{ opacity: disabled ? '0.5' : '1.0' }"
        @click="apply"
      >
        申请成为分销员
      </div> -->
	  <div class="apply-box">
      <van-button :disabled="disabled" :loading="loading" block color="#3377ff" @click="apply">申请成为分销员</van-button>
	  </div>
      <van-popup v-model="showProtocol">
        <div class="protocol-box">
          <div class="protocol-title">用户注册协议</div>
          <div class="content-box">
            <div class="protocol-content"  v-html="protocolContent"/>
          </div>
          <div class="agree-btn" @click="agree">同意此协议</div>
          <div class="refund-btn" @click="refund">拒绝</div>
          <div class="close" @click="close">x</div>
        </div>
      </van-popup>
    </div>
    <div class="status-box" v-if="currentStatus == 2 || currentStatus == 3">
      <img class="status-img" :src="getStatusImg" />
      <p class="status-text">{{ getStatusText }}</p>
      <div class="desc-box">
        <p class="status-desc">{{ getStatusDesc }}</p>
      </div>
      <div v-if="status != '2'" class="status-btn" @click="clickStatusBtn">
        {{ getStatusBtn }}
      </div>
    </div>
  </div>
</template>
<script>
// import { isPhone, isIdCardNumber } from "@/utils/validate";
import registProgress from "@/components/regist-progress.vue";
import { getImgUrl } from "@/mixins/getImgUrl";
import { getOrgId } from "@/utils/index";
import {Dialog} from 'vant';
export default {
  components: { registProgress },
  mixins: [getImgUrl],
  data() {
    return {
      statusList: ["填写信息", "等待审核", "完成注册"],
      currentStatus: 1,
      name: "",
      account: "",
      psw: "",
      pswAgain: "",
      // idCard: "",
      recommand: "默认分销商",
	  agencyName:"",//运营商名称
	  address:"",//运营商地址
	  bankBalance:"",//开户行
	  cardNo:"",//银行卡号
	  tenantId:"",
      checked: true, //默认未选中
      disabled: true, //禁止状态
	  loading: false, //加载中
      showProtocol: false, //显示协议
      protocolContent:
        "本协议由您与江西赣游通国际旅行社有限公司（以下简称为“赣游通”）共同缔结，本协议具有合同效力。如需享受赣游通提供的服务，您应完全同意本协议；如果您不同意以下任何内容，请立刻停止访问/使用本网站或其他任何移动应用或软件所提供的相关服务。<br>本协议中协议双方合称协议方，本协议中“赣游通服务”指由江西赣游通国际旅行社有限公司根据本协议及/或随时对其的修改向您提供的基于互联网以及移动网的服务。本协议中“赣游通网站”指江西赣游通国际旅行社有限公司运营的旅游电子商务网站，赣游通平台，域名为distributor.ganyoutong.cn或公众号H5商城“赣游通平台”。本协议中“赣游通平台”指赣游通为用户所提供的网络交易平台。<br>一、接受条款<br>1、本协议内容包括协议正文及所有赣游通已经发布或将来可能发布的各类规则。所有规则为协议不可分割的一部分，与协议正文具有同等法律效力。<br>2、以任何方式进入赣游通并使用服务即表示您已充分阅读、理解并同意接受本协议的条款和条件(以下合称“条款”)。<br>3、赣游通有权根据业务需要酌情修订“条款”，并以网站公告的形式进行更新。经修订的“条款”，应在本页面及其相应页面提前公布通知，您应该定期登陆本页面及其他相关页面，了解最新的条款内容。变更后的条款或规则在本页面及相关页面公布后七天，将自动生效。如您不同意相关变更，应当立即停止访问赣游通或使用相关服务，若您在条款或规则变更七日后继续使用赣游通服务的，即表示您接受已经修订的条款或规则。<br>二、注册<br>1、定义<br>1.1 用户，指具有完全民事行为能力的赣游通各项服务的使用者且与赣游通签订《用户注册协议》并完成注册程序的用户。<br>2、 注册者资格<br>2.1 您确认，在您完成注册程序或以其他赣游通允许的方式实际使用赣游通服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且赣游通有权注销您的赣游通账户，并向您及您的监护人索偿。<br>如有合理理由怀疑您提供的资料错误、不实、过时或不完整的，赣游通有权向您发出询问及/或要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对您提供部分或全部赣游通服务，赣游通对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。<br>3、账户<br>3.1 在您签订本协议，完成注册程序或以其他赣游通允许的方式实际使用赣游通服务时，赣游通会向您提供唯一编号的赣游通账户（以下简称“账户”）。<br>3.2 您可以对账户设置密码，通过您的账户和密码登录网站。如您连续一年未使用您的账户和密码登录赣游通网站，则视为您自愿放弃赣游通提供的相关服务，赣游通有权终止为您提供赣游通服务或注销您的账户且赣游通不承担任何责任。<br>3.3 您应维持密码及账户的机密安全。您应对您的账户和密码的安全，以及任何人利用您的密码及账户所进行的活动负完全的责任，您知晓并理解，赣游通无法对非法或未经您授权使用您账帐号及密码的行为作出甄别，因此赣游通对此类账号风险不承担任何责任。如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即以有效方式通知赣游通，赣游通可配合暂停相关服务。您理解赣游通对您的请求采取行动需要合理时间进行判断，赣游通对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。除非有法律规定或司法裁定，且征得赣游通的同意，否则，账户和密码不得以任何方式转让、赠与或继承。<br>3.4 您应当准确填写并及时更新您提供的联系方式，以便赣游通与您进行有效联系，因通过这些联系方式无法与您取得联系，导致您在使用赣游通服务过程中产生任何损失或增加费用的，应由您独自承担全部责任。<br>三、服务内容<br>1、赣游通服务的具体内容由赣游通根据实际情况提供，赣游通对其提供之服务拥有最终解释权。<br>2、赣游通服务中的某些服务是以收费方式提供的，用户使用收费服务需要向赣游通支付一定的费用。对于收费服务，赣游通会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用并完成相关手续及或签订相关协议，用户才能使用该等收费服务。如用户拒绝支付相关费用，则赣游通有权不向用户提供该等收费服务。收费服务的收费标准视具体服务而定，收费规则以各项收费服务所公布的相关规则、说明为准。<br>3、您理解，赣游通仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由您自行负担。<br>四、赣游通服务使用规范<br>1、在使用赣游通服务过程中，您承诺遵守以下约定：<br>1.1 在使用赣游通服务过程中实施的所有行为均遵守国家法律、法规、其他规范性文件及赣游通各项协议、规则的约定和规范，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及赣游通相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担全部法律责任，并确保赣游通免于因此产生任何损失。<br>1.2 在赣游通交易平台与其他会员进行交易过程中，遵守诚实信用原则，不采取不正当竞争行为，不扰乱网上交易的正常秩序，不从事与网上交易无关的行为。<br>1.3 不在赣游通网站发布任何违法或违规信息，包括但不限于任何妨碍社会治安或非法、虚假、骚扰性、侮辱性、恐吓性、伤害性、破坏性、挑衅性、淫秽色情性等内容的信息、涉嫌侵犯他人知识产权或其它合法权益的信息、违背社会公共利益或公共道德或赣游通认为不适合在赣游通网站发布的信息、国家禁止销售的或限制销售的商品或服务信息、其它涉嫌违法或违反本协议及赣游通各类规则的信息。<br>1.4 不对赣游通网站上的任何数据作商业性利用，包括但不限于在未经赣游通事先书面同意的情况下，以复制、传播等任何方式使用赣游通网站上展示的资料。<br>1.5 不使用任何装置、软件或例行程序干预或试图干预赣游通网站的正常运作或正在赣游通网站上进行的任何交易、活动。您不得采取任何将导致不合理的庞大数据负载加诸赣游通网站网络设备的行动。<br>2、您了解并同意：<br>2.1 赣游通有权对您是否违反上述承诺做出单方认定，并根据单方认定结果适用规则予以处理或终止向您提供赣游通服务，且无须征得您的同意或提前通知予您。<br>2.2 经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为，或者经赣游通判定，认为您的行为涉嫌违反本协议和/或规则的条款或涉嫌违反法律法规规定的，则赣游通有权在赣游通网站上公示您的该等涉嫌违法或违约行为及赣游通已对您采取的措施。<br>2.3 对于您在赣游通网站上发布/引用的涉嫌违法或涉嫌侵犯他人合法权利或违反本协议和/或规则的信息、资料等，赣游通有权不经通知您即予以删除，并按照相关规定进行处罚，同时由此给赣游通造损失的，还应承担赔偿责任。<br>2.4 对于您在赣游通网站上实施的行为，包括您未在赣游通网站上实施但已经对赣游通及其用户产生影响的行为，赣游通有权单方认定您行为的性质是否构成对本协议和/或规则的违反，并据此作出相应处罚。您应自行保存与您行为有关的全部证据，并应对无法提供充分证据而承担的不利后果。<br>2.5 对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保赣游通免于因此产生损失或增加费用，但由此给赣游通造损失的，应承担赔偿责任。<br>2.6 如您涉嫌违反有关法律或者本协议之规定，使赣游通遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿赣游通因此遭受的损失及（或）发生的费用，包括合理的律师费/诉讼费等所有的费用。<br>五、特别授权<br>您完全理解并不可撤销地授予赣游通下列权利：<br>1、一旦您向赣游通及（或）其关联公司作出任何形式的承诺，且相关公司已确认您违反了该承诺，则赣游通有权立即按您的承诺或协议约定的方式对您的账户采取限制措施，包括但不限于中止或终止向您提供赣游通服务、解除相关协议，并公示相关公司确认的您的违约情况等。您了解并同意，赣游通无须就相关确认与您核对事实，或另行征得您的同意，且赣游通无须就此限制措施或公示行为向您承担任何的责任。<br>2、一旦您违反本协议，或与赣游通签订的其他协议的约定，赣游通有权以任何方式通知赣游通关联公司，要求其对您的权益采取限制措施，包括但不限于要求与赣游通合作的第三方支付公司将您账户内的款项支付给赣游通指定的对象，要求关联公司中止、终止对您提供部分或全部服务，且在其经营或实际控制的任何网站公示您的违约情况。<br>3、您在赣游通交易平台所进行的交易过程中与其他会员发生交易纠纷时，一旦您或其它会员任一方或双方共同提交赣游通要求调处，则赣游通有权受理您与其他会员因交易产生的争议，并有权根据单方判断与该争议相关的事实及应适用的规则做出调处决定，您了解并同意接受赣游通的判断和调处决定。该决定将对您具有法律约束力。如您未在限期内执行处理决定的，则赣游通有权利（但无义务）对您执行限制措施，包含但不限于以任何方式通知赣游通关联公司，要求其对您的权益采取限制措施，及/或要求关联公司中止、终止对您提供部分或全部服务。您理解并同意，赣游通并非司法机构，仅能以普通人的身份对证据进行鉴别，赣游通对争议的调处完全是基于您的委托，赣游通无法保证争议处理结果符合您的期望，也不对争议调处结论承担任何责任。如您因此遭受损失，您同意自行向受益人索偿。<br>六、责任范围和免责声明<br>1、您理解并接受，赣游通所提供的服务仅依其当前所呈现的状况提供，服务可能会受到各个环节不稳定因素的影响。赣游通服务存在不可抗力、电脑、通讯或其他系统的故障、电力故障，计算机病毒或黑客攻击、系统不稳定、罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为等造成的服务中断或不能满足您要求的风险，您在使用赣游通服务的同时须承担以上风险，赣游通对此不承担任何责任。赣游通对其提供的服务不作任何明示或暗示的保证，包括但不限于赣游通服务的适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途。同时，赣游通也不对赣游通服务所涉及的技术及信息的有效性、准确性、正确性、可靠性、质量、稳定、完整和及时性作出任何承诺和保证。<br>2、如赣游通的系统发生故障影响到赣游通服务的正常运行，赣游通承诺在第一时间内与相关单位配合，及时处理进行修复。但您因此而产生的经济损失，赣游通不承担责任。此外，赣游通保留不经事先通知为维修保养、升级或其他目的暂停赣游通服务任何部分的权利。<br>3、赣游通在此郑重提请您注意，任何经由赣游通所提供的服务以上载、张贴、发布信息或任何其他方式传送的资讯、资料、文字、软件、音乐、音讯、照片、图形、视讯、信息、会员的登记资料或其他资料（以下简称“内容”），无论系公开还是私下传送，均由内容提供者承担责任。赣游通无法控制经由赣游通服务传送之内容，也无法对用户的使用行为进行全面控制，因此不保证内容的合法性、正确性、完整性、真实性或品质。您已预知使用赣游通服务时，可能会接触到令人不快、不适当或令人厌恶之内容，并同意将自行加以判断并承担所有风险，而不依赖于赣游通。在无相关法律规定的情况下，赣游通不履行对于用户传送的内容的定期确认，监督的义务。但在任何情况下，赣游通有权依相关法律法规或者赣游通相关规则采取相应行动，包括但不限于暂停用户使用赣游通服务的全部或部分，保存有关记录，并向有关机关报告。但赣游通有权(但无义务)依其自行之考量，拒绝和删除可经由赣游通服务提供之违反本协议及赣游通相关规则的或其他引起赣游通或其他用户反感的任何内容。<br>4、赣游通交易平台仅作为您获取物品或服务信息、物色交易对象、就物品和/或服务的交易进行协商及开展交易的场所。平台上的信息系用户自行发布，且可能存在风险和瑕疵。对于您在赣游通交易平台上所进行的一切交易行为，赣游通无法控制交易所涉及的物品的质量、安全或合法性，商贸信息的真实性或准确性，以及交易各方履行其在贸易协议中各项义务的能力，赣游通对此一律不负任何担保责任。您应自行谨慎判断确定相关物品及/或信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。<br>5、您了解并同意，赣游通不对因包括但不限于下述任一情况而导致您的任何损害承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿，包括但不限于利润、商誉、使用、数据、资料等方面的损失或其它无形损失的损害赔偿 (无论赣游通是否已被告知该等损害赔偿的可能性) ：<br>5.1 使用或未能使用赣游通服务。<br>5.2 第三方未经批准的使用您的账户或更改您的数据。<br>5.3 通过赣游通服务购买或获取任何商品、样品、数据、信息或进行交易等行为或替代行为所产生的费用及损失。<br>5.4 您对赣游通及或对赣游通服务的误解。<br>5.5 任何非因赣游通的原因而引起的与赣游通服务有关的其它损失。<br>6、除非法律法规明确要求，或出现以下情况，否则，赣游通没有义务对所有会员的注册数据、商品（服务）信息、交易行为以及与交易有关的其它事项进行事先审查：<br>6.1 赣游通有合理的理由认为特定会员及具体交易事项可能存在重大违法或违约情形。<br>6.2 赣游通有合理的理由认为会员在赣游通网站的行为涉嫌违法违规或不当。<br>7、您经由赣游通取得的建议和资讯，无论其形式或表现，绝不构成本协议未明示规定的任何保证。<br>8、赣游通网站提供与其它互联网上的网站或资源的链接，您可能会因此连结至其它运营商经营的网站，但不表示赣游通与这些运营商有任何关系。其它运营商经营的网站均由各经营者自行负责，不属于赣游通控制及负责范围之内。对于存在或来源于此类网站或资源的任何内容、广告、产品或其它资料，赣游通亦不予保证或负责。因使用或依赖任何此类网站或资源发布的或经由此类网站或资源获得的任何内容、物品或服务所产生的任何损害或损失，赣游通不负任何直接或间接的责任。<br>七、赣游通服务的变更、中断或终止<br>1、赣游通服务的所有权和运作权、一切解释权归江西赣游通国际旅行社有限公司。<br>2、赣游通有权按需要修改或变更所提供的收费服务、收费标准、收费方式、服务费、及服务条款。赣游通在提供赣游通服务时，可能现在或日后对部分赣游通服务的用户开始收取一定的费用。如用户拒绝支付该等费用，则不能在收费开始后继续使用相关的赣游通服务。但赣游通将尽最大努力通过公告或其他有效方式通知用户有关的修改或变更。<br>3、您同意，赣游通有权自行全权决定以任何理由经或不经事先通知随时修改变更赣游通服务内容、中断或中止部分或全部赣游通服务，且无须为此向您或任何第三方承担任何责任。<br>4、您理解，赣游通需要定期或不定期地对提供赣游通服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成赣游通服务（包括收费服务）在合理时间内的中断，赣游通无需为此承担任何责任，但赣游通应尽可能事先进行通告。<br>5、如发生下列任何一种情形，赣游通有权随时中断或终止向您提供赣游通服务（包括收费服务）而无需对您或任何第三方承担任何责任，且所有已付款项不予退还：<br>5.1 您提供的个人资料不真实或不准确或不及时或不完整。<br>5.2 您违反本协议或赣游通相关规则的规定。<br>5.3 本协议（含规则）变更时，您明示并通知赣游通不愿接受新的服务协议的。<br>5.4 赣游通终止向您提供赣游通服务后，您涉嫌再一次直接或间接或以他人名义注册为赣游通会员的。<br>5.5 其它赣游通认为应当终止赣游通服务的情况。6、您有权向赣游通要求注销您的账户，经赣游通审核同意，由赣游通注销您的账户，届时，您与赣游通基于本协议的协议关系即终止。您的账户被注销后，赣游通没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。<br>7、您同意，您与赣游通的协议关系终止后，赣游通仍享有下列权利：<br>7.1 赣游通有权继续保存您的注册信息及您使用服务期间的所有相关信息。<br>7.2 您在使用赣游通服务期间存在违法行为或违反本协议和/或赣游通相关规则的行为的，赣游通仍可依据本协议向您主张权利。<br>8、赣游通中止或终止向您提供赣游通服务后，对于您在赣游通服务中止或终止之前的交易行为依下列原则处理，您应独立处理并完全承担进行以下处理所产生的任何争议、损失或增加的任何费用，并应确保赣游通免于因此产生任何损失或承担任何费用：<br>8.1 您在赣游通服务中止或终止之前已经上传至赣游通网站交易平台的物品或服务信息尚未交易的，赣游通有权在中止或终止赣游通服务的同时删除此项物品或服务信息的相关信息。<br>8.2 您在赣游通服务中止或终止之前已经与其他会员达成买卖合同，但合同尚未实际履行的，赣游通有权删除该买卖合同及其交易物品或服务信息的相关信息。<br>8.3 您在赣游通服务中止或终止之前已经与其他会员达成买卖合同且已部分履行的，赣游通可以不删除该项交易，但赣游通有权在中止或终止赣游通服务的同时将相关情形通知您的交易对方。<br>9、赣游通若因您的行为侵害了第三方的权利或违反了相关规定，而受到第三方的追偿或受到主管机关的处分时，您应赔偿赣游通因此所产生的一切损失及费用。<br>八、知识产权<br>1、为更好的满足您在赣游通所享有的服务，对于您提供的资料及数据、信息（包括但不限于注册资料、交易行为数据及全部展示于赣游通的各类信息），您授予赣游通及其关联方独家的、全球通用的、永久的、免费的许可使用权利 (并有权在多个层面对该权利进行再授权)。此外，赣游通及其关联方有权(全部或部份地) 使用、复制、修订、改写、发布、翻译、分发、执行和展示您的全部资料及数据、信息（包括但不限于注册资料、交易行为数据及全部展示于赣游通的各类信息）或制作其派生作品，并以现在已知或日后开发的任何形式、媒体或技术，将上述信息纳入其它作品内。<br>2、赣游通对于您利用赣游通服务或赣游通网站的文字、资料、图片等侵害他人的著作权、肖像权等的情况，不承担任何责任。如果发生由于您侵害他人的著作权，肖像权等的情况，赣游通被第三者告发、起诉，涉及损失赔偿等时，您必须声明其行为与赣游通无关且赣游通不负任何法律责任。<br>3、您应对通过赣游通网站或其他移动终端上传/发表的任何文字、资料、图片等内容的真实性、合法性负责，保证对该等内容拥有完整的、无瑕疵的所有权和知识产权或拥有完整的授权，并不存在任何侵犯第三方合法权益的情形，包括但不限于著作权、肖像权、商标权、专利权、企业名称权、商号权、商业秘密、个人隐私、合同权利等权利。所有因用户非法上传内容而给任何第三方或赣游通及其关联方造成的损害均由用户承担全部的责任。如您在赣游通网站或其他移动终端发表的内容存在上述任一情形，赣游通有权在不事先通知您的情况下自行移除相关内容，并依法保留相关数据。<br>4、赣游通在赣游通服务中提供的任何文本、图片、图形、音频和视频资料均受版权、商标权以及其他相关法律法规的保护。未经赣游通事先同意，任何人不能擅自复制、传播这些内容，或用于其他任何商业目的，所有这些资料或资料的任何部分仅可作为个人或非商业用途而保存在某台计算机内。赣游通为提供服务而使用的任何软件（包括但不限于软件中的任何文字、图形、音频、视频资料及其辅助资料）的一切权利属于该软件的著作权人，未经该著作权人同意，任何人不得对该软件进行反向工程、反向编译或反汇编。<br>九、隐私条款<br>1、赣游通严格保障您的隐私权，保护您个人信息的安全。我们使用多种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。您自愿注册个人信息，您在注册时提供的所有信息，都是基于自愿，您有权在任何时候拒绝提供这些信息。注册个人信息的会员同意赣游通对这些信息进行善意利用。除法律或政府要求或您的允许等原因外，赣游通未经您的同意不向除关联公司或合作单位以外的第三方公开、透露您的个人信息。但因下列原因而披露给第三方的除外，且不承担任何法律责任：<br>1.1 基于国家法律法规的规定而对外披露。<br>1.2 应国家司法机关及其他有关机关基于法定程序的要求而披露。<br>1.3 符合赣游通公布的相关协议或各类规则的约定。<br>1.4为保护赣游通或您的合法权益而披露。<br>1.5 在紧急情况下，为保护赣游通员工、赣游通产品或其他用户及第三方的人身安全而披露。<br>1.6您本人或您的监护人授权披露的。<br>1.7应您的监护人合法要求而提供您的个人身份信息时。<br>2、有下列情况之一的，赣游通不承担任何法律责任：<br>2.1 由于您将用户密码告知他人或与他人共享注册账户，而导致的任何个人资料泄露；<br>2.2 任何由于黑客攻击、计算机病毒侵入或发作、政府管制等造成的暂时性关闭，使网络无法正常运行而造成的个人资料泄露、丢失、被盗用或被窜改；<br>2.3 由于第三方对您的个人信息的使用而导致的任何个人信息泄漏，如果我们对该第三方的信息批露是被允许的；<br>2.4 因不可抗力而引起的任何后果。<br>3、尊重用户隐私始终是赣游通的一项重要制度。您在使用赣游通服务前已仔细阅读并确认您已经充分理解隐私条款所写明的内容，并与赣游通达成协议并接受所有的服务条款；同时，在您使用赣游通服务过程中，您对赣游通不定期更新的隐私条款以及在赣游通网站其他位置公布的隐私政策及规则条款均表示接受。否则，您应当立即停止访问赣游通或使用相关服务。<br>4、我们会从关联公司、业务合作伙伴、供应商来获得您的相关信息。例如当您使用我们关联公司、业务合作伙伴提供的服务时，您向其提供的信息可能会转交给我们，以便我们处理您的需求，更好的为您服务。我们将依据与关联公司、业务合作伙伴的约定，对这些个人信息来源的合法性进行确认。您完全同意并接受我们通过上述方式获得的您的个人信息。<br>十、不可抗力<br>1、因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本协议所称之不可抗力意指不能预见、不能避免并不能克服的客观情况，包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、法定疾病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等客观情况。<br>十一、法律管辖及其他<br>1、本协议的订立、执行和解释及争议的解决均应适用中国法律。<br>2、如协议方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向赣游通所在地的人民法院提起诉讼。<br>3、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。<br>4、除本协议外，我们在赣游通网站及其他任何移动应用或软件上不定期发布或更新的相关规则、政策、制度及协议等共同构成您在使用赣游通服务时对双方的约束条款，您在享受赣游通提供的服务时，即代表您接受相关规则、制度、政策等。<br>5、本协议中的标题仅为方便而设，在解释本协议时应被忽略。<br>本协议最终解释权归赣游通所有。",
      status: "", //审核状态(0审核通过1禁用2待审核3审核驳回)
      auditOpinion: "", //审核意见
	  distributorsData: "",//注册的分销商ID
	  distributorsName: "",//注册的分销商名称
    };
  },
  computed: {
    getStatusImg() {
      if (this.currentStatus == 2) {
        if (this.status == "2") {
          return require("@/assets/apply-ing.png");
        }
        return require("../../assets/apply-fail.png");
      } else if (this.currentStatus == 3) {
        return require("@/assets/apply-success.png");
      }
      return require("@/assets/apply-ing.png");
    },
    getStatusText() {
      if (this.currentStatus == 2) {
        if (this.status == "3") {
          return "申请已驳回";
        }
        return "申请已提交";
      } else if (this.currentStatus == 3) {
        return "恭喜已注册成为分销员";
      }
      return "申请已提交";
    },
    getStatusDesc() {
      if (this.currentStatus == 2) {
        if (this.status == "2") {
          return "请耐心等待审核,审核预计需要2-3个工作日";
        }
        return this.auditOpinion;
      } else if (this.currentStatus == 3) {
        return "";
      }
      return "请耐心等待审核,审核预计需要2-3个工作日";
    },
    getStatusBtn() {
      if (this.currentStatus == 2) {
        return "重新申请";
      } else if (this.currentStatus == 3) {
        return "访问首页";
      }
      return "";
    },
  },
  methods: {
    validator(val) {
      if(!val) return false;
      const reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[@#$%^&+=])(?=.*[a-zA-Z0-9@#$%^&+=]).{8,}$/;
      return reg.test(val);
    },
    validatorAgain(val){
      return val === this.psw;
    },
    clickStatusBtn() {
      if (this.getStatusBtn == "重新申请") {
        this.currentStatus = 1;
        this.name = "";
        this.account = "";
        this.psw = "";
        this.pswAgain = "";
        // this.idCard = "";
        this.disabled = true;
        this.checked = true;
      } else if (this.getStatusBtn == "访问首页") {
        //this.$router.push({ path: "/login" });
		this.$router.push({ path: "/index" });
      }
    },
    checkProtocol() {
      //用户协议
      this.showProtocol = true;
    },
    agree() {
      this.checked = true;
      this.close();
    },
    refund() {
      this.checked = false;
      this.close();
    },
    close() {
      this.showProtocol = false;
    },
    inputFunc(event) {
      this.vaildInput();
    },
	getOrgInfo() {
	  var tenantId = getOrgId();
	  this.$API.user.getSystemAgencyId(tenantId).then((res) => {
	    this.orgName = res.data.name || "";
		this.agencyName = res.data.agencyName || "";
		this.tenantId = res.data.agencyId || "";
	  });
	},
	getAgencyInfo() {
	  var tenantId = getOrgId();
	  this.$API.user.getInfoAgencyId(tenantId).then((res) => {
	    this.address = res.data.address || "";
		this.bankBalance = res.data.bankBalance || "";
		this.bankAccountName = res.data.bankAccountName || "";
		this.cardNo = res.data.cardNo || "";
	  });
	},
    vaildInput() {
      var isOk = true;
      if (
        this.name.length == 0 ||
        this.account.length == 0 ||
        this.psw.length == 0 ||
        this.pswAgain.length == 0
        //this.idCard.length == 0
      ) {
        isOk = false;
      }
      if (this.psw != this.pswAgain) {
        isOk = false;
      }
      // if (!isIdCardNumber(this.idCard)) {
      //   isOk = false;
      // }
      this.disabled = !isOk;
    },
    apply() {
      if (this.disabled) return;
      this.loading = true ;
      this.disabled = false;
      if (!this.checked) {
        this.$toast("您需要同意用户注册协议");
        return;
      }
      this.$refs['formData'].validate()
        .then(() => {
          let tokenObj = JSON.parse(localStorage.tokenObj);
          let userInfo_v2 = JSON.parse(localStorage.userInfo_v2);
          let data = {
            userName: this.account,
            password: this.psw,
            name: this.name,
            // idCardNo: this.idCard,
            straightId: userInfo_v2.identity.straightId, //"169735975010373",// ROLE_INFO.id,
            distributorsId: this.distributorsData || userInfo_v2.identity.distributorId, //ROLE_INFO.distributorsId,
            accId: tokenObj.acc_id,
          };
          this.$API.user.straightUpgrade(data)
            .then((res) => {
              if (res.code == 200) {
                this.currentStatus = 2;
                this.status = "2";
              }
            })
            .finally(() => {
              setTimeout(() => {
                this.loading = false;
              }, 500)
            }); 
        })
        .catch(err => {
          this.loading = false;
          if(Array.isArray(err) && err.length > 0) {
            this.$toast(err[0].message);
          }
        })
      
    },
    initInfo() {
	  let userInfo_v2 = JSON.parse(localStorage.userInfo_v2);
	  //通过分享ID查询分销商ID
	  let staffid = this.$route.query.shareId;
	  if (staffid == undefined){
		  Dialog.confirm({
		    message:'未查询到推荐人，请刷新重试或点击取消注册至默认分销商下。',
			confirmButtonText:'重试',
			//cancelButtonText:'关联默认分销商',
		  })
		    .then(() => {
			   location.reload();
		       // on confirm
		    })
		    .catch(() => {
		      // on cancel
		    });
	  }else{
		  this.$API.user.getStaffById(staffid).then((res)=>{
		  			  this.recommand = res.data.staffName;
		  			  this.distributorsData = res.data.distributorsId;
		  			  //console.log("查询分销商",this.distributorsData,this.recommand);
		  }).catch(err => {})
	  }
      this.$API.user
        .selectStaffRegisterSituation(userInfo_v2.user.userId)
        .then((res) => {
          //console.log(res);
          this.status = res.data.status;
          if (this.status == "0") {
            this.currentStatus = 3;
          } else if (this.status == "2") {
            //待审核
            this.currentStatus = 2;
          } else if (this.status == "3") {
            //审核驳回
            this.currentStatus = 2;
          } else if (this.status == "4") {
            //未注册
            this.currentStatus = 1;
            this.account = userInfo_v2.user.mobile;
          }
          this.auditOpinion = res.data.auditOpinion || "";
        })
        .catch((error) => {});
    },
  },
  mounted() {
    this.initInfo();
	//this.getOrgInfo();
	//this.getAgencyInfo();
  },
};
</script>
<style lang="scss">
.box {
  background-color: #f4f6f9;
  height: 100%;
  .content {
    background-color: #ffffff;
  }
  .select-box {
    margin-top: vw(79);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .user-Protocol {
      margin-left: vw(15);
      color: rgba($color: #3377ff, $alpha: 0.7);
      font-size: vw(30);
    }
  }
  .apply-btn {
    margin-top: vw(46);
    margin-left: vw(30);
    margin-right: vw(30);
    border-radius: vw(8);
    height: vw(88);
    line-height: vw(88);
    text-align: center;
    background-color: #3377ff;
    color: #ffffff;
    font-size: vw(30);
  }
  .apply-box {
    margin-top: vw(46);
    margin-left: vw(30);
    margin-right: vw(30);
    border-radius: vw(8);
  }
  .protocol-box {
    position: relative;
    border-radius: vw(12);
    width: vw(660);
    background-color: #ffffff;
    border-radius: vw(8);
    display: flex;
    flex-direction: column;
    align-items: center;
    .protocol-title {
      color: #000000;
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: vw(32);
      margin-top: vw(45);
    }
    .content-box {
      overflow: hidden;
      margin-left: vw(36);
      margin-right: vw(36);
      margin-top: vw(30);
      height: vw(700);
      .protocol-content {
        height: vw(700);
        overflow-y: scroll;
        font-size: vw(24);
        color: #000000;
      }
    }
    .agree-btn {
      color: #ffffff;
      font-size: vw(30);
      background-color: rgba($color: #3377ff, $alpha: 1);
      border-radius: vw(8);
      text-align: center;
      height: vw(88);
      width: vw(560);
      line-height: vw(88);
      margin-top: vw(23);
    }
    .refund-btn {
      color: #ffffff;
      font-size: vw(30);
      background-color: rgba($color: #999999, $alpha: 1);
      border-radius: vw(8);
      text-align: center;
      height: vw(88);
      width: vw(560);
      line-height: vw(88);
      margin-top: vw(23);
      margin-bottom: vw(30);
    }
    .close {
      font-size: vw(40);
      //   font-weight: bold;
      color: #c2c5cc;
      position: absolute;
      right: vw(26);
      top: vw(10);
    }
  }
  .status-box {
    margin-top: vw(200);
    display: flex;
    flex-direction: column;
    align-items: center;
    .status-img {
      width: vw(168);
      height: vw(168);
      object-fit: contain;
    }
    .status-text {
      margin-top: vw(51);
      color: #000000;
      font-size: vw(32);
    }
    .desc-box {
      text-align: center;
      .status-desc {
        color: #999999;
        font-size: vw(24);
        margin-top: vw(10);
        width: vw(560);
        line-height: vw(43);
        text-align: center;
      }
    }

    .status-btn {
      margin-top: vw(190);
      border-radius: vw(8);
      border: vw(1) #3377ff solid;
      color: #3377ff;
      font-size: vw(30);
      line-height: vw(88);
      height: vw(88);
      width: vw(560);
      text-align: center;
    }
  }
}
</style>
